<template>
    <!-- 팝업 -->
    <div class="pop_up_layer find_account" style="display: block"></div>
    <div class="pop_up pop_detail" style="display: block">
        <button class="close_btn icon_wrap" @click="closeModal">
            <img src="img/close.png" alt="닫기" />
        </button>

        <div class="pop_tit">
            <p>신청하기</p>
        </div>

        <div class="custom_scroll question_list" style="margin-top: 30px">
            <div v-for="(question, formIdx) in state.questionList">
                <label class="title">{{ question.orderNo + ". " + question.title }}</label>

                <template v-if="question.caseList && question.caseList.length > 0 && question.type !== 3">
                    <ul v-if="question.type === 1">
                        <li v-for="answer in question.caseList" class="radio_wrap cnt p_5">
                            <label :for="'radio_' + question.idx + '_' + answer.idx">
                                <input
                                    type="radio"
                                    :name="`radio_${question.idx}`"
                                    :id="'radio_' + question.idx + '_' + answer.idx"
                                    :value="answer.idx"
                                    v-model="state.answerData[formIdx].caseList[0]"
                                />
                                <em></em>
                                <span v-html="answer.title"></span>
                                <input
                                    v-if="answer.title === '기타' && answer.idx === state.answerData[formIdx].caseList[0]"
                                    type="text"
                                    v-model="state.answerData[formIdx].answer"
                                    placeholder="내용을 입력해주세요"
                                />
                            </label>
                        </li>
                    </ul>
                    <ul v-if="question.type === 2">
                        <li v-for="answer in question.caseList" class="checkbox_wrap cnt p_5">
                            <label :for="'chk_' + question.idx + '_' + answer.idx">
                                <input
                                    type="checkbox"
                                    :id="'chk_' + question.idx + '_' + answer.idx"
                                    :value="answer.idx"
                                    v-model="state.answerData[formIdx].caseList"
                                />
                                <em></em>
                                <span v-html="answer.title"></span>
                                <input
                                    v-if="answer.title === '기타' && state.answerData[formIdx].caseList.some((item) => item === answer.idx)"
                                    type="text"
                                    v-model="state.answerData[formIdx].answer"
                                    placeholder="내용을 입력해주세요"
                                />
                            </label>
                        </li>
                    </ul>
                </template>

                <template v-if="question.type === 3">
                    <div>
                        <input type="text" v-model="state.answerData[formIdx].answer" placeholder="답변을 적어주세요." />
                    </div>
                </template>
            </div>
        </div>

        <div class="btn_wrap _default _center">
            <button class="submit_btn w_120" @click="save">완료</button>
        </div>
    </div>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="state.isShowModal = false"
    ></ModalDefault>
</template>
<script lang="ts">
    import { onMounted, reactive, watch, onUnmounted, CommonUtils, types, ModalDefault } from "@/BaseComponent";

    interface Question {
        idx: number;
        type: number;
        title: string;
        orderNo: number;
        caseList: types.BoardApplyCaseVOForApi[];
        answer: string;
    }

    export default {
        props: {
            list: {
                type: Array,
                defalut: [],
            },
            answerData: {
                type: Array,
                defalut: [],
            },
        },
        emits: ["close", "save"],
        components: { ModalDefault },
        setup(props: any, { emit }: any) {
            const state = reactive({
                questionList: [] as Question[],
                currentIdx: 0 as number,
                cnt: 0 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                answerData: [] as { formIdx: number; answer: string; caseList: number[] }[],
            });

            onMounted(() => {
                state.currentIdx = 0;
                state.questionList = props.list;

                document.body.style.overflow = "hidden";
                setDefaultAnswer();
            });

            watch(props, () => {
                state.currentIdx = 0;
                state.questionList = props.list;
                setDefaultAnswer();
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            const closeModal = () => {
                emit("close");
            };

            const setDefaultAnswer = () => {
                state.questionList.forEach((question) => {
                    state.answerData.push({
                        formIdx: question.idx,
                        answer: "",
                        caseList: [],
                    });
                });
            };

            const save = () => {
                if (!checkValue()) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "작성하지 않은 답변이 있습니다.";
                    state.isShowModal = true;
                } else {
                    emit("save", state.answerData);
                }
            };

            const checkValue = () => {
                let isSuccess = true;
                const etcQuestion = state.questionList.filter((q) => q.caseList && q.caseList.some((cs) => cs.title === "기타"));

                if (etcQuestion.length > 0) {
                    const etcIdx = etcQuestion.map((etc) => etc.idx);
                    isSuccess = state.answerData.every((answer) => {
                        if (answer.caseList && answer.caseList.length > 0) {
                            return answer.caseList.every((caseItem) => {
                                if (etcIdx.includes(caseItem)) return !!answer.answer;
                                else return true;
                            });
                        } else {
                            return !!answer.answer;
                        }
                    });
                } else {
                    isSuccess = state.answerData.every((answer) => {
                        if (answer.caseList.length > 0) {
                            return true;
                        } else {
                            return !!answer.answer;
                        }
                    });
                }
                return isSuccess;
            };

            return { state, closeModal, props, CommonUtils, save };
        },
    };
</script>

<style scoped>
    .pop_up {
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .table_btn {
        color: #fff;
        font-weight: 500;
        background-color: var(--main_color);
        border-radius: 5px;
        font-size: 13px;
        padding: 0 5px;
    }

    label.title {
        font-family: Noto Sans KR;
        font-weight: 500;
        font-style: Medium;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: 0%;
    }

    div.question_list {
        display: flex;
        flex-direction: column;
        gap: 20px;
        max-height: 50dvh;
        overflow-y: auto;
    }

    div.question_list li.radio_wrap {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    div.question_list li input {
        margin-top: 0;
    }

    ul {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    ul li input + em,
    ul li input + em + span {
        color: #252525;
    }

    ul li span {
        font-family: Noto Sans KR;
        font-weight: 500;
        font-style: Medium;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: 0%;
    }

    ul li input:checked + em,
    ul li input:checked + em + span {
        color: #001c92;
    }

    input[type="text"] {
        height: 40px;
        border: 1px solid #d9d9d9;
        border-radius: 5px;
        font-family: sans-serif;
        font-size: 16px;
        padding: 10px;
        margin-top: 5px;
        width: 100%;
    }
</style>
